import { Order } from '../../domain/entities/order-entity';
import { OrderRepository } from '../../domain/repositories/order-repository';
import { getOrders } from '../datasources/get-orders';
import { terminateOrder } from '../datasources/terminate-order';

export class OrderRepositoryImpl implements OrderRepository {
  async GetOrders(client_id: string): Promise<Order[]> {
    const orders = await getOrders(client_id);

    return orders.map((order: any) => new Order(order));
  }

  async TerminateOrder(client_id: string, order_id: string, trip_id: string): Promise<any> {
    return await terminateOrder(client_id, order_id, trip_id);
  }
}
